import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PermissionGuard = ({ children }) => {
  const { canRead } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;

    const routePermissions = {
      "/dashboard": ["AccessERPag", "ERPagDashboard"],
      "/workorder": ["AccessERPag", "ERPagWorkOrder"],
      "/alerts": ["AccessERPag", "ERPagAlerts"],
      "/analytics": ["AccessERPag", "ERPagAnalytics"],
      "/on-hold": ["AccessERPag", "ERPagOnHold"],
      "/transfers": ["AccessERPag", "ERPagTransfers"],
      "/products": ["AccessERPag", "ERPagProducts"],
      "/products-settings": ["AccessERPag", "ERPagAssignedValues"],
      "/customer-shipping-schedule": [
        "AccessERPag",
        "ERPagCustomerShippingSchedule",
      ],
      "/UserAndPermissionsManagement": [
        "AccessUserPermissionManagement",
        "UsersPermissionsPage",
      ],
      "/acelynk": ["AccessAceLynk", "AceLynkXML"],
      "/costing-tool": ["AccessCosting", "CostingToolPage"],
      "/generated-upcs": ["AccessCosting", "CostingGeneratedUPCs"],
      "/costing-settings": ["AccessCosting", "CostingSettingsPage"],
      "/bom-db": ["AccessCosting", "CostingBOMDB"],
    };

    const requiredPerms = routePermissions[currentPath] || [];

    if (requiredPerms.length && !requiredPerms.every((perm) => canRead(perm))) {
      let fallback = "/no-access"; // default

      if (canRead("AccessERPag")) {
        fallback = "/dashboard";
      } else if (canRead("AccessAceLynk")) {
        fallback = "/acelynk";
      } else if (canRead("AccessCosting")) {
        fallback = "/costing-tool";
      } else if (canRead("AccessUserPermissionManagement")) {
        fallback = "/UserAndPermissionsManagement";
      }

      console.log(`Access revoked for ${currentPath} → redirecting to ${fallback}`);
      navigate(fallback, { replace: true });
    }
  }, [canRead, location.pathname, navigate]);

  return children;
};

export default PermissionGuard;
